<template>
  <div class="mt-8">
    <px-view-module-header module-name="Empresa" :breadcrumbs="breadcrumbs"/>
    <px-view-header-title class="mt-8" title="Minha empresa"/>
    <v-card
      class="mx-auto rounded-card card-shadow"
    >
      <v-card-text v-if="loading">
        <px-circular-loading/>
      </v-card-text>
      <v-card-text v-if="!loading" class="pa-5">
        <p class="headline font-weight-bold mb-1 text--primary">
          {{ empresa.pessoa.nome }}
          <px-show-avaliacao-icon-simple class="ml-2"
                                         :avaliacao="entidade.pontuacaoMedia"/>
        </p>
        <p>
          <v-icon>mdi-domain</v-icon>
          {{ empresa.pessoa.cnpj | cnpj }}
        </p>
        <div class="text--primary">
          <v-icon>mdi-map-marker</v-icon>
          {{ empresa.endereco | endereco }}
        </div>
      </v-card-text>
    </v-card>
    <px-minha-empresa-tabs v-if="empresa" class="mt-3" :empresa="empresa"/>
  </div>
</template>

<script>
import EntidadeService from '@/api/entidade-service';
import FornecedorService from '@/api/fornecedor-service';
import MinhaEmpresaTabs from './MinhaEmpresaTabs.vue';

export default {
  data() {
    return {
      loading: false,
      empresa: null,
      entidade: null,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Minha empresa' },
      ],
    };
  },
  created() {
    this.loading = true;
    FornecedorService.get()
      .then((response) => {
        [this.empresa] = response.data;
        return EntidadeService.getEntidade()
          .then(({ data }) => {
            this.entidade = data;
          });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  components: {
    pxMinhaEmpresaTabs: MinhaEmpresaTabs,
  },
};
</script>
